<template>
  <div class="container-fluid customer-media-container">
    <!-- home img
    <b-row>
      <b-col lg="2" md="5" cols="5" class="mx-auto">
       
      </b-col>
    </b-row> -->
    <!-- title -->
    <b-row class="">
      <b-col xl="6" lg="8" class="mx-auto mt-md-4 mt-3">
        <h2 class="welcomeUserHomeH2DY mb-0">Close Your Eyes and Listen</h2>
      </b-col>
    </b-row>
    <!-- <MediaSimpleCardList
      :list_title="playlist_title"
      :list_items="tracks"
    /> -->
    <b-card
      class="card-transparent-background card-media-container-doomyoga mt-1"
      :title="playlist_title"
    >
      <CoolLightBox
        class="customer-media-lightbox-doomyoga"
        :items="tracks"
        :index="index"
        loop
        thumbsPosition="bottom"
        :srcName="'video_src'"
        @close="index = null"
      >
      </CoolLightBox>

      <div class="images-wrapper">
        <b-row>
          <b-col
            xl="2"
            lg="2"
            md="4"
            sm="6"
            cols="6"
            class="image"
            v-for="(item, itemIndex) in tracks"
            :key="itemIndex"
          >
            <SimpleMediaCard
              client_name="DY"
              :title="item.title"
              :duration="item.duration"
              :img_src="item.thumb"
              @click.native="setIndex(itemIndex)"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import MediaSimpleCardList from "@/components/media_components/MediaSimpleCardList.vue";
import SimpleMediaCard from "@/components/media_components/SimpleMediaCard.vue";
import CoolLightBox from "vue-cool-lightbox";
import axios from "axios";

export default {
  name: "DoOmYogaCustomerMeditationVideoPlaylist",
  components: { MediaSimpleCardList, CoolLightBox, SimpleMediaCard },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
      playlist_title: "",
      playlist_id: null,

      tracks: [],
      index: null,
    };
  },
  mounted() {
    this.playlist_id = this.$route.params.id;
    console.log(this.playlist_id);
    // this.selected_category = [Number(this.$route.params.id)];
    this.getVideosRequest();
  },
  methods: {
    setIndex(index) {
      console.log("click card ", index);
      this.index = index;
    },
    getVideosRequest() {
      axios
        .get("/media/library/category/" + this.playlist_id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.library_media);
          console.log(response.data.library_media.length);
          this.playlist_title = response.data.title;
          this.tracks = [];
          for (let i = 0; i < response.data.library_media.length; i++) {
            let media = response.data.library_media[i];
            this.tracks.push({
              id: media.id,
              title: media.title,
              description: media.description,
              duration: media.time_duration,
              mediaType: "webVideo",
              autoplay: true,
              video_src: media.media.full_path,
              thumb: media.cover_image.full_path,
            });
          }

          // this.tracks = this.tracks.concat(this.tracks);
          // this.tracks = this.tracks.concat(this.tracks);
        });
    },
  },
};
</script>

<style scoped::v-deep >
</style>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Meditation/VideosList.vue